import {all} from 'redux-saga/effects';

import {createFetchSagaLatest} from 'utils/sagas';

import {
  fetchLiveAvailability as fetchLiveAvailabilityAction,
  fetchOccupancyReportForPeriod as fetchOccupancyReportForPeriodAction,
  fetchOccupancyReportForRoomPurposes as fetchOccupancyReportForRoomPurposesAction
} from './';

import {
  fetchOccupancyReportForPeriod,
  fetchOccupancyReportForRoomPurposes,
  fetchLiveAvailability
} from 'sdk/occupancy';

function* occupancySaga() {
  yield all([
    createFetchSagaLatest(
      fetchOccupancyReportForPeriodAction,
      fetchOccupancyReportForPeriod
    ),
    createFetchSagaLatest(fetchLiveAvailabilityAction, fetchLiveAvailability),
    createFetchSagaLatest(
      fetchOccupancyReportForRoomPurposesAction,
      fetchOccupancyReportForRoomPurposes
    )
  ]);
}

export default occupancySaga;
